module.exports = __webpack_public_path__ + "static/media/delet.872ac840.svg";